import { render, staticRenderFns } from "./TasksCard.vue?vue&type=template&id=7c419864"
import script from "./TasksCard.vue?vue&type=script&lang=js"
export * from "./TasksCard.vue?vue&type=script&lang=js"
import style0 from "./TasksCard.vue?vue&type=style&index=0&id=7c419864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports